import {Slide, ToastContainer} from 'react-toastify';

import {AUTO_CLOSE_DEFAULT} from './constants';

import 'react-toastify/dist/ReactToastify.css';

const contextClass = {
    default: 'tw-bg-light tw-text-dark',
    success: 'tw-bg-success-light tw-text-default',
    error: 'tw-bg-alert-light',
    info: 'tw-bg-light tw-text-dark tw-rounded-xl',
    warning: 'tw-bg-warning-light tw-text-dark',
    dark: 'tw-bg-primary-dimmed', // loading
};

const toastClassName = ({type}: {type?: string}) =>
    contextClass[type || 'default'] +
    ` vs-notification vs-notification-${type} tw-min-h-16` +
    ' tw-flex tw-cursor-default tw-shadow-md tw-rounded-xl' +
    ' tw-justify-between tw-p-1 tw-m-1 tw-pl-4';

export const NotifierContainer = () => (
    <ToastContainer
        position='top-center'
        autoClose={AUTO_CLOSE_DEFAULT}
        hideProgressBar
        newestOnTop
        closeOnClick
        toastClassName={toastClassName}
        bodyClassName='tw-flex tw-w-full'
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover
        transition={Slide}
    />
);